window.addEventListener('DOMContentLoaded', () => {
  const videoElements = document.querySelectorAll('video-element')
  if (!videoElements.length) return
  videoElements.forEach((ele) => {
    const video = ele.querySelector('video')
    if (video && video.style.display === 'none') {
      video.remove()
    }
  })
})